import type { TrafficSignalNode } from './reguladores-placeholder';
import type { SignalPositionOverride } from './overridesRuntime';

/** Aplica correcciones de posición sobre los nodos OSM de semáforos. */
export function applySignalPositionOverrides(
  base: TrafficSignalNode[],
  overrides: SignalPositionOverride[],
): TrafficSignalNode[] {
  if (overrides.length === 0) return base;
  const byId = new Map(overrides.map(o => [o.id, o.position]));
  return base.map(s => {
    const position = byId.get(s.id);
    return position ? { ...s, position } : s;
  });
}
